import { ColorSchemeNamesInput } from '@razorpay/blade/tokens';

export const getThemePreference = (): ColorSchemeNamesInput => {
  let themePreference = localStorage.getItem('theme') || 'dark';

  if (themePreference !== 'light' && themePreference !== 'dark') {
    themePreference = 'dark';
  }

  return themePreference as ColorSchemeNamesInput;
};
